import React, { useState, useRef } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Animated,
} from 'react-native';
import { useCssStyle } from '../../customHook/getCssStyle';
import { ImageComp } from '../Image/Image';
import { CHEVRON_RIGHT } from '../../assets';
import CustomCheckBoxWithProps from '../checkBox/customCheckBox';

export const CustomDrawer = (props) => {
  const {
    label,
    options = [],
    selectedOption = null,
    onSelectOption,
    warningText,
    defaultOpen = false,
  } = props || {};

  const getStyles = useCssStyle();

  const shouldBeOpen = defaultOpen || options.length === 1 || selectedOption !== null;  // auto-open condition

  const [isOpen, setIsOpen] = useState(shouldBeOpen);
  const animatedHeight = useRef(new Animated.Value(shouldBeOpen ? 1 : 0)).current;
  const animatedRotation = useRef(new Animated.Value(shouldBeOpen ? 1 : 0)).current;

  const toggle = () => {
    const toValue = isOpen ? 0 : 1;
    Animated.parallel([
      Animated.timing(animatedHeight, {
        toValue,
        duration: 250,
        useNativeDriver: false,
      }),
      Animated.timing(animatedRotation, {
        toValue,
        duration: 250,
        useNativeDriver: true,
      }),
    ]).start();
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (item) => {
    if (item.disabled) return;
    onSelectOption?.(item);
  };

  const estimatedMaxHeight = options.length * 56 + 16;

  const animatedStyle = {
    maxHeight: animatedHeight.interpolate({
      inputRange: [0, 1],
      outputRange: [0, estimatedMaxHeight],
    }),
    overflow: 'hidden',
    opacity: animatedHeight,
  };

  const chevronStyle = {
    transform: [
      {
        rotate: animatedRotation.interpolate({
          inputRange: [0, 1],
          outputRange: ['0deg', '90deg'],
        }),
      },
    ],
  };

  return (
    <View style={getStyles(['drawerMaincontainer'])} id='drawerMaincontainer'>
      <TouchableOpacity
        onPress={toggle}
        activeOpacity={0.7}
        style={getStyles(['drawerHeaderContainer'])}
        id="drawerHeaderContainer"
      >
        <View style={getStyles(['drawerHeaderTextContainer'])} id='drawerHeaderTextContainer'>
          <Text style={getStyles(['drawerHeaderTitle'])} id='drawerHeaderTitle'>
            {label}
          </Text>
          {isOpen && warningText ? (
            <View style={getStyles(['drawerWarningBadge'])} id='drawerWarningBadge'>
              <Text style={getStyles(['drawerWarningText'])} id='drawerWarningText'>
                {warningText}
              </Text>
            </View>
          ) : null}
        </View>

        <Animated.View style={chevronStyle} id="drawerToggleIcon">
          <ImageComp source={CHEVRON_RIGHT} style={getStyles(['drawerToggleIcon'])} />
        </Animated.View>
      </TouchableOpacity>

      <View style={getStyles(['drawerDivider'])} />

      <Animated.View style={animatedStyle}>
        {options.map((item, index) => {
          const isSelected = item.value === selectedOption;
          const isLast = index === options.length - 1;

          return (
            <TouchableOpacity
              key={item.value ?? index}
              onPress={() => handleSelect(item)}
              activeOpacity={item.disabled ? 1 : 0.6}
              style={getStyles(['drawerOptionRow', item.disabled ? {opacity: 0.7} : {}])}
              id='drawerOptionRow'
            >
              <CustomCheckBoxWithProps
                style={getStyles(["checkbox"])}
                id="checkbox"
                value={isSelected || false}
              />

              <Text id='drawerOptionLabel' style={getStyles(['drawerOptionLabel', item.disabled ? {opacity: 0.7} : {}])}>
                {item.label}
              </Text>

              {!isLast && (<View id='drawerRowDivider' style={getStyles(['drawerRowDivider'])}/>)}
            </TouchableOpacity>
          );
        })}
      </Animated.View>
    </View>
  );
};

export default CustomDrawer;